function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SDropdownV3, SField } from "../..";
export const NavigationPropertyEditor = ({ value, onChangeValue, readOnly, onClickValue })=>{
    const transitionOptions = [
        "none",
        "push",
        "fade",
        "slide"
    ].map((transition)=>({
            label: transition === "none" ? "No Transition" : transition.charAt(0).toUpperCase() + transition.slice(1),
            value: transition
        }));
    const setProps = (newProps)=>{
        let props = {
            type: "property-navigation",
            transition: "none"
        };
        onChangeValue && onChangeValue(_object_spread({}, props, value, newProps));
    };
    return /*#__PURE__*/ _jsx("div", {
        onClick: onClickValue,
        children: /*#__PURE__*/ _jsx("div", {
            className: readOnly ? "pointer-events-none" : "",
            children: /*#__PURE__*/ _jsx(SField, {
                children: /*#__PURE__*/ _jsx("div", {
                    className: "flex flex-col gap-2",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "grid grid-cols-2 gap-3 items-center",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                children: "Transition"
                            }),
                            /*#__PURE__*/ _jsx(SDropdownV3, {
                                borderless: false,
                                options: transitionOptions,
                                value: transitionOptions.find((option)=>option.value === (value === null || value === void 0 ? void 0 : value.transition)),
                                onChange: (transition)=>{
                                    setProps({
                                        transition: transition.value
                                    });
                                }
                            })
                        ]
                    })
                })
            })
        })
    });
};
